import React from "react";
import ReactPlayer from "react-player/vimeo";
import {
  VideoIconAndTypography,
  IconAndTypographyContainer,
  VideoPlayContainer,
  StyledPlayVideo,
  VideoDiv,
} from "./VideoEmbed.styles";
import unityMother from "../../../assets/images/unityMother.png";
import { GetTypographyContent } from "../Typography/Typography";
import { useDeviceHook } from "../../../utils/hooks/useDeviceHook";

const VideoEmbed: React.FC<{
  overlayText: React.ReactNode;
  videoUrl: string;
  thumbnailImage?: string;
  variant?: "page" | "panel";
}> = ({
  overlayText,
  videoUrl,
  thumbnailImage = unityMother,
  variant = "page",
}) => {
  const { deviceType } = useDeviceHook();
  const isPanelVariant = variant === "panel";
  const playerHeight =
    isPanelVariant || deviceType === "desktop" ? "100%" : "328px";

  const videoOverlay = (
    <VideoPlayContainer deviceType={deviceType} $variant={variant}>
      {GetTypographyContent({
        content: overlayText,
        size: isPanelVariant ? "medium" : "h3",
        textColor: "white",
        isBold: true,
        padding: isPanelVariant ? "0" : "10px",
      })}
      <IconAndTypographyContainer>
        <VideoIconAndTypography>
          <StyledPlayVideo />
          {GetTypographyContent({
            content: "Watch the video",
            size: isPanelVariant ? "small" : "xlarge",
            textColor: "white",
            isBold: true,
          })}
        </VideoIconAndTypography>
      </IconAndTypographyContainer>
    </VideoPlayContainer>
  );

  return (
    <VideoDiv $variant={variant}>
      <ReactPlayer
        playing
        url={videoUrl}
        playIcon={videoOverlay}
        light={thumbnailImage}
        height={playerHeight}
        width="100%"
        controls
        data-testid="unity-video-player"
        data-vimeo-playsinline
        data-vimeo-autoplay
      />
    </VideoDiv>
  );
};

export default VideoEmbed;
